import { useRef, useState } from 'react'
import type ReactECharts from 'echarts-for-react'
import { useSocialAreaData } from '../../../hooks/useSocialAreaData'
import SocialAreaScatterChart from '../../../chart/SocialAreaScatterChart'
import { RiskProfileCard } from '../../RiskProfileCard'
import { ChartQueryState } from '../../ChartQueryState'
import { ChartExportActions } from '../../../chart/ChartExportActions'
import { useExportXlsx } from '../../../hooks/useExportXlsx'
import { useExportChartImage } from '../../../hooks/useExportChartImage'
import { InterpretToggle, InterpretPanel } from '../../InterpretToggle'
import type {
  PropertiesQueryParams,
  PropertiesMetricOption,
} from '../../../types/riskProfileProperties.types'

export interface SocialAreaScatterWidgetProps {
  queryParams: PropertiesQueryParams | null
  metricOption: PropertiesMetricOption
}

export function SocialAreaScatterWidget({
  queryParams,
  metricOption,
}: SocialAreaScatterWidgetProps) {
  const [showInterpret, setShowInterpret] = useState(false)
  const { request, query } = useSocialAreaData(queryParams)
  const { exportXlsx, isExporting } = useExportXlsx(request, '/report/risk-profile/properties/xlsx')
  const chartRef = useRef<ReactECharts>(null)
  const handleExportImage = useExportChartImage(chartRef, 'residents-exposed-by-area-scatter')

  return (
    <RiskProfileCard
      title="Number and share of residents exposed"
      description="Number and share of residents exposed, by area."
      onExport={
        <div className="flex items-center gap-2">
          <InterpretToggle active={showInterpret} onClick={() => setShowInterpret((v) => !v)} />
          <ChartExportActions
            onExportXlsx={exportXlsx}
            onExportImage={handleExportImage}
            isExportingXlsx={isExporting}
            xlsxDisabled={!request}
          />
        </div>
      }
      className="min-h-96"
    >
      {showInterpret && (
        <InterpretPanel>
          {/* TODO: get content for InterpretPanel */}
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
          <p>Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
          <p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris.</p>
        </InterpretPanel>
      )}
      <ChartQueryState query={query}>
        {(data) => (
          <SocialAreaScatterChart
            ref={chartRef}
            data={data}
            metricOption={metricOption}
            entityNoun="residents"
          />
        )}
      </ChartQueryState>
    </RiskProfileCard>
  )
}
